<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Human Landing Catch Enrollment
      </h2>
      <p class="tw-italic tw-text-gray-700">
        
      </p>
    </b-container>

    <b-container fluid class="tw-mb-5">
      <b-row class="tw-bg-gray-100 tw-border tw-border-blue-200">
        <b-col cols="9" class="tw-overflow-x-scroll" ref="hlcCollectionsCompleteChart">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
        </b-col>
        <b-col cols="3">
          <b-container>
            <b-row style="position: relative; top: 30px;">
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Total Completed
                    </p>
                    <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">
                      {{ totalCore }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col>
                
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>


      <b-card header-tag="nav" style="width: 100%; margin: 0;">
      <b-card-text>
        <b-row>
          <b-col class="text-right"><h2 style="position: relative; top: -3px;">Cluster:</h2></b-col>
          <b-col class="text-left"><b-select :options="clusters" v-model="selected_cluster" style="width: 100px;"></b-select></b-col>
        </b-row>
      </b-card-text>
      </b-card>

    <b-container>
      <b-row style="padding: 20px;">
      <b-col>
        <div style="padding-bottom: 50px;">
          <b-table striped hover :items="core" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
              <template v-slot:cell(enrollment_status)="data">
                <i class="fa fa-clock" style="color: #6c757d; font-size: 22px;" v-if="data.item.enrollment_status == 'pending'" title="Visitation Pending"></i>
                <i class="fa fa-check text-success" style="font-size: 22px;" v-if="data.item.enrollment_status == 'completed'" title="Visit Completed"></i>
                <i class="fa fa-user-times text-danger" style="font-size: 22px;" v-if="data.item.enrollment_status == 'omitted'" title="Removed due to lack of subjects"></i>
                <i class="fa fa-user" style="color: #004199; font-size: 22px;" v-if="data.item.enrollment_status == 'collecting'" title="Collection Occurring"></i>
                <i class="fa fa-calendar-check" style="color: #b0d300; font-size: 22px;" v-if="data.item.enrollment_status == 'pre-enrolled'" title="Pre-enrolled"></i>
              </template>
            </b-table>
            <b-alert v-if="error_message" variant="danger" show><i class="fas fa-exclamation-triangle"></i> {{ error_message }}</b-alert>
            <b-button v-else class="float-right" variant="success" @click="get_next_page()">More</b-button>
        </div>
      </b-col>
    <!-- </b-row>
    <b-row style="padding: 20px; position: relative; top: -50px;"> -->
      <b-col>
        <div>
          <b-card header-tag="nav">
            <b-card-text class="text-center">
              <h4 class="tw-font-bolder tw-mb-0 text-center">Enrollment Status</h4>
              <!-- <p class="text-secondary tw-text-xs text-center">Subheader for single number, if needed</p>
              <h1
                class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
              >{{raw}}</h1> -->

              <b-container>
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_removed }}
                    </h1>
                    <span>Omitted</span>
                  </b-col>
                  <b-col cols="auto" class="text-center" v-b-modal.enrolled_core_modal>
                    <h1 class="tw-text-6xl tw-font-bolder">
                      {{ core_enrolled.length }}
                    </h1>
                    <span class="tw-text-2xl">Enrolled</span>
                  </b-col>
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_pending }}
                    </h1>
                    <span>Remaining</span>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-text>
          </b-card>
         </div>
      </b-col>
    </b-row>
    </b-container>
    

    <b-modal id="enrolled_core_modal" title="Enrolled Compounds in CORE" ok-only>
      <span class="font-italic" v-if="core_enrolled.length == 0">No compounds have been enrolled yet.</span>
      <b-table striped hover borderless v-if="core_enrolled.length > 0" :items="core_enrolled" :fields="modal_fields">
             
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

import BarChart from "@/components/charts/BarChart.vue";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    BarChart
  },
  data: function() {
    return {
     clusters: [],
     cluster_ids: [],
     light_traps: [],
     light_traps_next_month: [],
     selected_cluster: null,
     core: [],
     core_next_month: [],
     current_page: 1,
     core_removed: 0,
     core_enrolled: [],
     core_pending: 0,
     next_month_scheduled: true,
     loaded: false,
     error_message: null,
     fields: [
       { key: 'order', label: 'Order'},
       { key: 'actual_compound_id', label: 'Compound', class: 'text-right' },
       { key: 'enrollment_status', label: 'Status', class: 'text-center'}
     ],
     modal_fields: [
       { key: 'order', label: 'Order'},
       { key: 'actual_compound_id', label: 'Compound', class: 'text-right' }
     ],
     next_fields: [
        { key: 'order' },
        { key: 'actual_compound_id', label: 'Compound', class: 'text-right' }
      ],

      coreTarget: 4,
      totalCore: 0,
      clustersReachedCoreTarget: 0,
      light_trap_clusters: [],
      clusterEnrollment: {
        chartdata: {
          datasets: [
            {
              label: "Core",
              backgroundColor: "red",
              data: [45, 23]
            },
          ],
          labels: [1, 2]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18
            }
          },
          title: {
            display: true,
            text: "HLC Collections Complete"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster"
                }
              }
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment Count"
                },
                ticks: {
                  beginAtZero: true,
                  // makes the steps whole numbers
                  callback: function(value){
                    if(value % 1 === 0){
                      return value;
                    }
                  }
                }
              }
            ]
          }
        },
        myStyles: {
          height: "25vh",
          width: "100vh",
          position: "relative"
        }
      }
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/hlc/get_cluster_list").then(response => {
      _.each(response.data, function(item){
        that.clusters.push(item);
        that.cluster_ids.push(item);
        that.light_trap_clusters.push(item);
      });
      that.selected_cluster = response.data[0];
    });
    that.get_hlc_overview();
  },
  watch: {
    selected_cluster: function(){
      let that = this;
      that.current_page = 1;
      that.get_hlc_by_cluster();
    }
  },
  methods: {
    get_next_page: function(){
      this.current_page += 1;
      this.get_hlc_by_cluster(false);
    },
    get_hlc_by_cluster: function(reset){
    let that = this;
    let reset_list = true;
    if(reset == false){
      reset_list = false;
    }
      HTTP.get("/kenya/hlc/get_status?page_number="+that.current_page+"&cluster="+that.selected_cluster).then(response => {
        if(reset_list == true){
          that.light_traps = [];
        }
        
        for(var i = 0; i < response.data.length; i++){
          that.light_traps.push(response.data[i]);
        }
        that.get_lighttraps();

      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    get_hlc_overview: function(){
      let that = this;
      HTTP.get("/kenya/hlc/get_overview").then(response => {
       let datasets = [
          {
            label: "Core",
            backgroundColor: "#37B1CA",
            data: []
          },
          {
            type: "line",
            backgroundColor: "red",
            borderColor: "red",
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            label: "Core Target",
            data: []
          }
        ];

        let labels = [];
        let core = {};

         _.each(response.data, function(item) {
              if(item.cluster in core){
                core[item.cluster].push(item);
              }
              else{
                core[item.cluster] = [
                  item
                ];
              }
          });

          for (let x_i = 0; x_i < that.light_trap_clusters.length; x_i++) {
            let x = parseInt(that.light_trap_clusters[x_i]);
            let idx_str = String(x);

            // populate the core series
            if (idx_str in core) {
              datasets[0].data.push(core[idx_str].length);
              that.totalCore += core[idx_str].length;

              if(core[idx_str].current_enrollment_count >= that.coreTarget) {
                that.clustersReachedCoreTarget += 1;
              }
            } else {
              datasets[0].data.push(0);
            }

            labels.push(x);
            datasets[1].data.push(that.coreTarget);
          }

          that.clusterEnrollment.chartdata.datasets = datasets;
          that.clusterEnrollment.chartdata.labels = labels;
          that.loaded = true;

          setTimeout(function() {
            that.$refs['hlcCollectionsCompleteChart'].scrollLeft = that.$refs['hlcCollectionsCompleteChart'].scrollWidth / 7;
          }, 500);
      });
    },
    get_lighttraps: function(){
      let that = this;
      that.core = [];
      that.core_removed = 0;
      that.core_enrolled = [];
      that.core_pending = 0;
      that.core_next_month = [];
      that.error_message = null;
      
      // This month:
      for(var i = 0; i < that.light_traps.length; i++){
        if(that.light_traps[i].cluster == that.selected_cluster){
          if(that.light_traps[i].sent_to_commcare == true){
            that.core.push(that.light_traps[i]);

            // if(that.light_traps[i].enrollment_status == 'pending'){
            //   that.core_pending += 1;
            // }
            if(that.light_traps[i].enrollment_status == 'omitted'){
              that.core_removed += 1;
            }
            if(that.light_traps[i].enrollment_status == 'completed' || that.light_traps[i].enrollment_status == 'collecting' || that.light_traps[i].enrollment_status == 'pre-enrolled'){
              that.core_enrolled.push(that.light_traps[i]);
            }
          }
        }
      }
      that.core_pending = that.coreTarget - that.core_enrolled.length;

      if(that.core.length == 0){
        that.error_message = 'HLC Schedules have not yet been pushed to CommCare';
      }
      if(that.light_traps.length == 0){
        that.error_message = 'HLC Schedules have not yet been generated';
      }
    }
  }
};
</script>

<style>
</style>